const GAPI_URL = 'https://www.google.com/maps/dir/'

export function getDirectionsUrl(address: string): string {
  const directionsUrl = new URL(GAPI_URL)
  directionsUrl.searchParams.set('api', '1')
  directionsUrl.searchParams.set('destination', address)

  return directionsUrl.toString()
}
